




import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { BasicCouponResourceModel } from '@/modules/coupon/models/coupon-resource.model'

@Component
export default class AdminCouponTitle extends Vue {
  @Prop({ required: true }) couponResource!: BasicCouponResourceModel

  get content() {
    if (!this.couponResource) return ''
    return `${this.couponResource.code} (${this.couponResource.amount})`
  }
}
